<template>
    <div v-if="showInfoModal">
        <div class="popupModal" :class="{active: showInfoModal}">
            <div class="popupModal__wrapper">
                <div class="popupModal__content">
                    <div>
                         <span class="close-icon" @click="onClose">
                             <img src="@/assets/icons/ic_close_white.svg">
                        </span>
                    </div>
                    <div class="main-content">
                        <div class="block-title">
                            {{ translate('vote_screen_public_review_popup_title') }}
                        </div>
                        <div class="block-social__subtitle" v-if="settings.social_subtitle !== ''">{{settings.social_subtitle}}</div>
                        <div class="block-btn__wrapper" v-for="(link, index) in settings.place_links.slice(0, 3)"
                             :key="index"
                             @click="onLinkClick(link)">
                            <div class="block-btn">
                                <img alt="" src="@/assets/icons/ic_facebook_color.svg" v-if="link.network.id == 1">
                                <img alt="" src="@/assets/icons/ic_yelp.svg" v-if="link.network.id == 2">
                                <img alt="" src="@/assets/icons/ic_google.svg" v-if="link.network.id == 3">
                                <img alt="" src="@/assets/icons/ic_tripadvisor_color.svg" v-if="link.network.id == 4">
                                <img alt="" src="@/assets/icons/ic_vk_color.svg" v-if="link.network.id == 6">
                                <img alt="" src="@/assets/icons/ic_instagram_color.svg" v-if="link.network.id == 5">
                                <img alt="" src="@/assets/icons/ic_web_color.svg" v-if="link.network.id == 7">
                                <img alt="" src="@/assets/icons/ic_donate.svg" v-if="link.network.alias == 'donate'">
                                <img alt="" src="@/assets/icons/ic_adopt.png" v-if="link.network.alias == 'adopt'">
                                <img alt="" src="@/assets/icons/ic_trustpilot.svg"
                                     v-if="link.network.alias == 'trustpilot'">
                                <img alt="" src="@/assets/icons/ic_capterra.svg"
                                     v-if="link.network.alias == 'capterra'">
                                <div>{{ link.network.name }}</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
import logAnalyticsEvent from '@/helpers/analytics'
import errorMixin from '@/mixins/errorMixin';


export default {
    name: "explainGeolactionPopup",

    mixins: [mixin, errorMixin],

    data() {
        return {
            showInfoModal: this.settings !== null,
        }
    },

    watch: {
        settings(newValue) {
            this.showInfoModal = newValue !== null
        }
    },

    props: {
        settings: {
            type: [Object, null],
            default: () => {
                return {}
            }
        },
    },

    methods: {
        async onClose() {
            logAnalyticsEvent('social_link_popup_close_click')
            this.showInfoModal = false
            if (this.settings.onCancelHandler) {
                try {
                    await this.settings.onCancelHandler(this.settings)
                } catch (error) {
                    this.showErrorModal(error.message)
                }
            }
        },
        onLinkClick(link) {
            if (this.settings.onLinkClickHandler) {
                try {
                    this.settings.onLinkClickHandler(link)
                } catch (error) {
                    this.showErrorModal(error.message)
                }
            }
        }
    }

}
</script>

<style scoped>
.main-content {
    text-align: center;
    color: black;
    margin-bottom: 0;
    margin-top: 25px;
    padding-bottom: 0;
}

.close-icon {
    position: absolute;
    right: 8px;
    top: 8px;
    z-index: 99999;
    width: 40px;
    height: 40px;
    display: flex;
}

.close-icon img {
    max-width: 20px;
    margin: auto;
}
.main-content__title {
    margin-top: 0;
    color: black;
    margin-bottom: 20px;
}

.block-title {
    margin-bottom: 20px;
}
.popupModal__content {
    margin: 14.75em auto;
}
.block-social__subtitle {
  margin-bottom: 25px;
  font-size: 18px;
  color: #3F405C;
    white-space: pre-line
}

@media screen and (max-width: 376px) {
    .popupModal__content {
        margin: 10em auto;
    }
    .block-social__subtitle {
      font-size: 15px;
    }
}

@media screen and (max-width: 321px) {
    .popupModal__content {
        margin: 8em auto;
    }
}


</style>
